






























































































import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class AboutDocument extends Vue {
  @Prop() readonly type!: string;
}
